import COUNTRIES from "../constants/countries";
import US_STATES, { ALL_USA_STATE } from "../constants/usStates";
import FIELDSNGO from "../constants/ngo";
import { FIELDS_BUSINESS, CATEGORY_BUSINESS, FIELDS_TYPES } from "../constants/business";
import { FIELDS_NEWS } from "../constants/news"
import { FIELDS_HOTSPOTS } from "../constants/hotSpots";
import { FIELDS_GREENSPOTS } from "../constants/greenSpots";
import { FIELDS_BLOG } from '../constants/blog'

export const getSearchOptions = (options) => {
  // eslint-disable-next-line default-case
  switch (options) {
    case "countries":
      return COUNTRIES;

    case "states":
      return [ALL_USA_STATE, ...US_STATES];
    case "usState":
    case "state":
      return US_STATES;

    case "businessFields":
      return FIELDS_BUSINESS;

    case "business":
      return FIELDS_BUSINESS;

    case "category":
      return CATEGORY_BUSINESS;

    case "NGO":
      return FIELDSNGO;
    case "hotSpot":
      return FIELDS_HOTSPOTS;
    case "greenSpot":
      return FIELDS_GREENSPOTS;
    case "media":
      return [{ value: 'all', label: 'all' }]
    case "government":
      return [{ value: 'all', label: 'all' }]
    case "organizationFields":
      return FIELDSNGO;

    case "newsFields":
      return FIELDS_NEWS

    case "blogFields":
      return FIELDS_BLOG

    case "type":
      return FIELDS_TYPES

    case "fields":
      return FIELDSNGO;
    //   case "searchType":
    //     return TYPE;
  }
};

export const getSearchNames = (options) => {
  // eslint-disable-next-line default-case
  switch (options) {
    case "countries":
      return "Countries";

    case "states":
    case "usState":
      return "State";

    case "businessFields":
      return "Business fields";

    case "category":
      return "Business category";

    case "organizationFields":
      return "Organization fields";

    case "searchType":
      return "Search type";
  }
};
